import React, { Component } from 'react';
import './AICompanies.css';

class AICompanies extends Component {
  render() {
    if (this.props.data) {
      let aiCompanies = this.props.data.map(aiCompany => {
        return (
          <tr>
            <td>{aiCompany.id}</td>
            <td>{aiCompany.companyName}</td>
            <td>{aiCompany.tenant.identifier}</td>
            <td>{aiCompany.isActive ? 'Active' : 'Not Active'}</td>
            <td>
              {new Date(aiCompany.meta.created).toLocaleDateString('en-US', {
                hour: '2-digit',
                minute: '2-digit'
              })}
            </td>
          </tr>
        );
      });

      return (
        <table>
          <thead>
            <tr>
              <td>Id</td>
              <td>Name</td>
              <td>TenantId</td>
              <td>Status</td>
              <td>Created Date</td>
            </tr>
          </thead>
          <tbody>{aiCompanies}</tbody>
        </table>
      );
    } else {
      return false;
    }
  }
}

export default AICompanies;
